module.exports = __webpack_public_path__ + "static/dashboard-c00f81cfca5935b0c56f2d62882b358d.png";